import BubbleChartWidget from './bubble-chart.widget';
import { bubbleWidgetSettings } from './widget-settings';
export default BubbleChartWidget;
export { bubbleWidgetSettings };
